'use client'

import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useCustomDataPageStore } from '@repo/store/useCustomDataPageStore'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import MUIStack from '@mui/material/Stack'
import { ListIcon } from '@repo/ui/ListIcon'

export const CustomDataFieldList = ({ isInlineEditMode, field, value, onChange, size = 'small' }) => {
  const { listValues, fetchListValues } = useCustomDataPageStore()
  const { customDataFieldListId, description } = field || {}

  useEffect(() => {
    if (customDataFieldListId && !listValues[customDataFieldListId]) {
      fetchListValues({ customDataListIds: [customDataFieldListId] })
    }
  }, [customDataFieldListId, listValues, fetchListValues])

  const listMeta = listValues[customDataFieldListId] || {}
  const options = listMeta.customDataListItemValues || []

  const name = description

  return (
    <div data-testid="CustomDataFieldList" style={{ width: '100%', maxWidth: '100%', position: 'relative' }}>
      <Adornment size={size} />
      <ReactSelectMenu
        label=""
        onChange={(e) => (e ? onChange(e.value) : onChange(null))}
        labelKey="value"
        valueKey="value"
        items={options}
        value={{ value }}
        searchable
        idLabelKey="value"
        showIdInResults={false}
        name={name}
        size={size}
        autoFocus={isInlineEditMode}
        hasAdornment
      />
    </div>
  )
}

CustomDataFieldList.propTypes = {
  isInlineEditMode: PropTypes.bool,
  field: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
  validationErrors: PropTypes.array,
  fieldTypeIsString: PropTypes.bool,
  fieldTypeIsNumber: PropTypes.bool,
  fieldTypeIsAnId: PropTypes.bool,
  size: PropTypes.string
}

const Adornment = ({ size = 'small' }) => {
  return (
    <MUIStack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        position: 'absolute',
        zIndex: 1,
        width: size === 'small' ? '40px' : '52px',
        height: '100%',
        backgroundColor: 'rgba(61, 81, 123, 0.04)',
        userSelect: 'none',
        pointerEvents: 'none',
        borderLeft: 'none',
        borderRight: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px 0px 0px 4px'
      }}
    >
      <ListIcon sx={{ width: '14px', height: '14px' }} />
    </MUIStack>
  )
}

Adornment.propTypes = {
  size: PropTypes.string
}
